/* tslint:disable */
/* eslint-disable */
/**
 * RLawyers API
 * API pour la plateforme Call a Lawyer
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@avoloi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateSollicitationDto } from '../models';
/**
 * SollicitationsApi - axios parameter creator
 * @export
 */
export const SollicitationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Permet à un juriste de solliciter un avocat en enregistrant les informations de contact en base de données
         * @summary Solliciter un avocat
         * @param {CreateSollicitationDto} createSollicitationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sollicitationsControllerSolliciterAvocat: async (createSollicitationDto: CreateSollicitationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSollicitationDto' is not null or undefined
            assertParamExists('sollicitationsControllerSolliciterAvocat', 'createSollicitationDto', createSollicitationDto)
            const localVarPath = `/sollicitations/solliciterAvocat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSollicitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SollicitationsApi - functional programming interface
 * @export
 */
export const SollicitationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SollicitationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Permet à un juriste de solliciter un avocat en enregistrant les informations de contact en base de données
         * @summary Solliciter un avocat
         * @param {CreateSollicitationDto} createSollicitationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sollicitationsControllerSolliciterAvocat(createSollicitationDto: CreateSollicitationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sollicitationsControllerSolliciterAvocat(createSollicitationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SollicitationsApi.sollicitationsControllerSolliciterAvocat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SollicitationsApi - factory interface
 * @export
 */
export const SollicitationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SollicitationsApiFp(configuration)
    return {
        /**
         * Permet à un juriste de solliciter un avocat en enregistrant les informations de contact en base de données
         * @summary Solliciter un avocat
         * @param {CreateSollicitationDto} createSollicitationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sollicitationsControllerSolliciterAvocat(createSollicitationDto: CreateSollicitationDto, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.sollicitationsControllerSolliciterAvocat(createSollicitationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SollicitationsApi - object-oriented interface
 * @export
 * @class SollicitationsApi
 * @extends {BaseAPI}
 */
export class SollicitationsApi extends BaseAPI {
    /**
     * Permet à un juriste de solliciter un avocat en enregistrant les informations de contact en base de données
     * @summary Solliciter un avocat
     * @param {CreateSollicitationDto} createSollicitationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SollicitationsApi
     */
    public sollicitationsControllerSolliciterAvocat(createSollicitationDto: CreateSollicitationDto, options?: RawAxiosRequestConfig) {
        return SollicitationsApiFp(this.configuration).sollicitationsControllerSolliciterAvocat(createSollicitationDto, options).then((request) => request(this.axios, this.basePath));
    }
}

